$ = require('jquery')

require('tinyscrollbar')

module.exports =
	init: (payload) ->
		{$target} = payload

		$target.find('.js-scrollbar--y').tinyscrollbar()
		$target.find('.js-scrollbar--x').tinyscrollbar(
			axis: 'x'
		)



// WEBPACK FOOTER //
// ./src/js/components/scrollbar.coffee